import {mapGetters} from "vuex";

export default {
    name: "Avatar",
    data() {
        return {
            currentUser: {
                avatar: null,
            },
        }
    },
    computed: {
        ...mapGetters({
            getUserCanRead: 'currentUser/getUserCanRead',
        }),
    },
    methods: {
        logoutUser() {
            localStorage.removeItem('token');
            window.location.href = '/';
        },
    }
}
